import { render, staticRenderFns } from "./TabPackages.vue?vue&type=template&id=1dfabe31&scoped=true&"
import script from "./TabPackages.vue?vue&type=script&lang=js&"
export * from "./TabPackages.vue?vue&type=script&lang=js&"
import style0 from "./TabPackages.vue?vue&type=style&index=0&id=1dfabe31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfabe31",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextField,VTextarea})
